/* dns-custom-socks-chaos.js — settle-on-reveal for the chaos mockup page.
   Adds .is-set to [data-x-reveal] elements as they enter the viewport; each
   element then rotates to its resting angle (--x-rot, set in CSS). No-JS and
   reduced-motion users see everything settled immediately. Also handles the
   division-flyer pre-select buttons ([data-x-tier-jump]) so they check the
   matching builder radio before the anchor scroll. */

(function () {
  'use strict';

  var roots = Array.prototype.slice.call(document.querySelectorAll('.dns-x'));
  if (!roots.length) return;

  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-x-tier-jump]');
    if (!jump) return;
    var radio = document.querySelector('input[name="dns-cs-tier"][value="' + jump.getAttribute('data-x-tier-jump') + '"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change'));
    }
  });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mobile order bar: mirror the live Grand Total (the builder JS binds each
     dns-cs hook to the first match only and dispatches no events, so a
     MutationObserver on the real total node is the only safe signal), jump to
     the judge's card on tap, and duck away while the card itself is on screen.
     Must run before the reduced-motion early return below. */
  var bar = document.querySelector('[data-x-bar]');
  if (bar) {
    var barTotal = bar.querySelector('[data-x-bar-total]');
    var barJump = bar.querySelector('[data-x-bar-jump]');
    var realTotal = document.querySelector('[data-dns-cs-total]');
    var judge = document.querySelector('[data-dns-cs-summary]');

    if (barTotal && realTotal) {
      /* hide again when the total blanks out — quote mode (201+ pairs) clears it, and a
         stale Grand Total under an email-only panel would be a lie */
      var syncBar = function () {
        var text = realTotal.textContent.trim();
        barTotal.textContent = text;
        bar.hidden = !text;
      };
      new MutationObserver(syncBar).observe(realTotal, { childList: true, characterData: true, subtree: true });
      syncBar();
    }

    if (barJump && judge) {
      barJump.addEventListener('click', function () {
        judge.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }

    if (judge && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-off', entries[0].isIntersecting);
      }, { threshold: 0.15 }).observe(judge);
    }
  }

  /* Sticky email rail (desktop only, CSS-gated at 981). Ducks away while the email band
     or the builder form is on screen so it never talks over the thing it points at, and
     stays dismissed for the rest of the session. Sits here, above the reduced-motion
     early return, for the same reason the order bar does. */
  var rail = document.querySelector('[data-x-rail]');
  if (rail) {
    var RAIL_KEY = 'dns-socks-rail-dismissed';
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(RAIL_KEY) === '1'; } catch (e) { /* storage off */ }

    if (dismissed) {
      rail.hidden = true;
    } else {
      var close = rail.querySelector('[data-x-rail-close]');
      if (close) {
        close.addEventListener('click', function () {
          rail.hidden = true;
          try { sessionStorage.setItem(RAIL_KEY, '1'); } catch (e) { /* non-fatal */ }
        });
      }

      /* The hero is a ducker too (Adam, 2026-07-30): the rail used to slide in over the
         hero's own CTA the moment the page loaded, competing with the button it is meant
         to be the alternative to. Same mechanism as the email band and the order summary —
         while the hero is on screen the rail stays parked off the bottom. */
      var duckers = Array.prototype.slice.call(
        document.querySelectorAll('[data-x-hero], [data-x-contact-band], [data-dns-cs-summary], [data-dns-cs-contact]')
      );

      if (duckers.length && 'IntersectionObserver' in window) {
        /* Park it before the first observer callback lands, or it paints on screen for a
           frame and then visibly slides back out — worse than never showing at all. */
        rail.classList.add('is-off');
        var onScreen = new WeakSet();
        var railIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) onScreen.add(entry.target);
            else onScreen.delete(entry.target);
          });
          rail.classList.toggle('is-off', duckers.some(function (el) { return onScreen.has(el); }));
        }, { threshold: 0.15 });
        duckers.forEach(function (el) { railIo.observe(el); });
      }
    }
  }

  var items = Array.prototype.slice.call(document.querySelectorAll('.dns-x [data-x-reveal]'));

  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('is-set'); });
    return;
  }

  roots.forEach(function (root) { root.classList.add('dns-x--js'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-set');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  items.forEach(function (el) { io.observe(el); });
})();
